export const ISSUES_GET_LIST = 'ISSUES_GET_LIST';
export const ISSUES_GET_LIST_SUCCESS = 'ISSUES_GET_LIST_SUCCESS';
export const ISSUES_GET_LIST_ERROR = 'ISSUES_GET_LIST_ERROR';
export const ISSUES_GET_LIST_WITH_FILTER = 'ISSUES_GET_LIST_WITH_FILTER';
export const ISSUES_GET_LIST_WITH_ORDER = 'ISSUES_GET_LIST_WITH_ORDER';
export const ISSUES_GET_LIST_SEARCH = 'ISSUES_GET_LIST_SEARCH';

export const MY_POSTS_GET_LIST = 'MY_POSTS_GET_LIST';


export const ISSUES_DELETE_ITEMS = 'ISSUES_DELETE_ITEMS';
export const ISSUES_DELETE_ITEMS_SUCCESS = 'ISSUES_DELETE_ITEMS_SUCCESS';
export const ISSUES_DELETE_ITEMS_ERROR = 'ISSUES_DELETE_ITEMS_ERROR';


export const ISSUES_SELECTED_ITEMS_CHANGE = 'ISSUES_SELECTED_ITEMS_CHANGE';
